module.exports = __webpack_public_path__ + "media/images/icons/filled/file-ppt-4bed7bf90b85bc8cc45c7641fd0eeacf.svg";